import { IAbUseExperiment } from '../../types/abUseExperiments';

export function getExperiment(experiments: IAbUseExperiment[], experimentName: string) {
  return experiments.find(o => o.experimentName === experimentName);
}
